module.exports = __webpack_public_path__ + "img/dashboard.5ab3311d.svg";